<template>
	<div class="orderpay">
		<el-dialog :visible.sync="showorderpay" :title="title" width="80%" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true" @close="DelPayOrderTemp">
			<div style="margin-top:-10px">
				<el-row>
					<el-col :span="16">
						<p style="font-size:12pt;font-weight:bold">
							本次操作
							<span style="color:#2e67c6">{{sourcelist.length }}</span>
							个订单
							<span style="margin-left:15px" v-if="zerolength>0">其中</span>
							<span v-if="zerolength>0" style="color:#f85200;margin-left:5px">{{ zerolength }}</span>
							<span v-if="zerolength>0" style="margin-left:5px">个订单实收金额为  0 </span>
						</p>
					</el-col>
					<el-col :span="7">
						<el-input v-model="searchbox" @keyup.enter.native="searchpayorder" placeholder="可按订单号\用户账号搜索" size="small" class="input-with-select">
							<el-button slot="append" size="mini" @click="searchpayorder">搜索</el-button>
						</el-input>
					</el-col>
					<el-col :span="1" style="color:transparent">1</el-col>
				</el-row>
				<el-row style="margin-top:10px;">
					<el-col>
						<tableui
							v-loading="loading"
							ref="orderpaylist"
							:tableData="orderpaylist"
							:columns="columns"
							:gridheight="gridheight"
							:rowclassname="tableRowClassName"
							:stripe="false"
						></tableui>
					</el-col>
				</el-row>
				<br/>
				<span slot="footer" class="dialog-footer">
					<el-row>
						<el-col :span="9">
							<p style="font-size:12pt;font-weight:bold">
								<span>应收总金额</span>
								<span style="color:#ffaa7f;margin-left:5px">{{ ys }}</span>
								<span v-show="iszb==0" style="margin-left:10px">实收总金额</span>
								<span v-show="iszb==0" style="color:#00aa00;margin-left:5px">{{ ss }}</span>
							</p>
						</el-col>
						<el-col :span="9" style="text-align:right;">
							<span v-show="iszb==0">支付方式：</span>
							<el-select  v-show="iszb==0" v-model="paytype" size="mini" style="width:200px">
								<el-option v-for="item in paytypelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-col>
						<el-col :span="3" style="text-align:center;"><el-button @click="surepay" size="mini" type="success" :disabled="btndisabled">确认收费</el-button></el-col>
						<el-col :span="3" style="text-align:center;"><el-button @click="downbill" size="mini" type="primary">下载账单</el-button></el-col>
					</el-row>
				</span>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="showsuccess" title="操作提示" width="400px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-error" style="color:#e6a727;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">计算失败,请点击下面失败详情按钮查看原因</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11" style="text-align:right;">
					<el-button type="danger" size="medium"><a :href="errorfile" target="_blank" style="color:#ffffff;text-decoration:none;">失败详情</a></el-button>
				</el-col>
				<el-col :span="7" style="text-align:center;"><el-button size="medium" @click="showsuccess=false">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
		<el-dialog :visible.sync="downsuccess" title="操作提示" width="400px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold">生成成功</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="11" style="text-align:right;">
					<el-button type="success" size="medium"><a :href="billname" target="_blank" style="color:#ffffff;text-decoration:none;">下载账单</a></el-button>
				</el-col>
				<el-col :span="7" style="text-align:center;"><el-button size="medium" @click="downsuccess=false">关闭</el-button></el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		
	},
	data() {
		return {
			loading: false,
			btndisabled:false,
			orderpaylist: [],
			columns: [],
			gridheight: '390px',
			searchbox: '',
			sourcelist: [], //原始的待支付列表
			zerolength: 0,
			ys: 0.00,
			ss: 0.00,
			showorderpay:false,
			paytype:'',
			paytypelist:[{label:'余额支付',value:'余额支付'},{label:'现金',value:'现金'},{label:'其他',value:'其他'}],
			pageparam:{},
			iszb:0,
			batch:'',
			errorfile:'',
			showsuccess:false,
			downsuccess:false,
			billname:'',
			title:''
		};
	},
	mounted() {
		this.columns = [
			{ colshow: '1', index: '0', align: 'left', field: 'p_pkval', title: '订单号', type: 'text', width: 100, sortable: 'custom', evttype: '', event: '' },
			{ colshow: '1', index: '1', align: 'left', field: 'u_account', title: '用户账号', type: 'text', width: 80, sortable: false, evttype: '', event: '' },
			{ colshow: '1', index: '2', align: 'left', field: 'amount', title: '应收金额', type: 'text', width: 100, sortable: 'custom', evttype: '', event: '' },
			{ colshow: '1', index: '3', align: 'left', field: 'changeamount', title: '实收金额', type: 'input', width: 80, sortable: false, evttype: 'change', event: '' },
			{ colshow: '1', index: '4', align: 'left', field: 'grossweight', title: '包裹重量', type: 'text', width: 80, sortable: false, evttype: '', event: '' },
			// { colshow: '1', index: '5', align: 'left', field: 'p_bagsort', title: '包裹分类', type: 'text', width: 80, sortable: false, evttype: '', event: '' },
			{ colshow: '1', index: '5', align: 'left', field: 'p_mode', title: '渠道', type: 'text', width: 70, sortable: false, evttype: '', event: '' },
			{ colshow: '1', index: '6', align: 'left', field: 'p_remark', title: '备注', type: 'text', width: 70, sortable: false, evttype: '', event: '' }
		];
	},
	methods: {
		tableRowClassName({ row, rowIndex }) {
			//汇总
			this.ordersum(true);
			if(row.changeamount!=""){
				if (parseFloat(row.changeamount) == parseFloat(0)) {
					return 'danger-row';
				} else {
					if (parseFloat(row.changeamount) != parseFloat(row.amount)) {
						return 'warning-row';
					} else return '';
				}
			}else return '';
		},
		init(param) {
			if(param.isdown==undefined)
				param.isdown=0;
			this.batch='';
			this.btndisabled=false;
			if(param.batch!=undefined)
				this.batch=param.batch;
			this.showorderpay=false;
			if(param.isdown==0){
				this.showorderpay=true;	
			}
			
			this.iszb=param.iszb;
			if(this.iszb=='1')
				this.title='总部收费';
			else
				this.title='门店收费';
			this.pageparam=param.pageparam;
			this.orderpaylist=[];
			this.sourcelist=[];
			this.CulatefeeOrder(param.isdown);
			if(this.iszb==1){
				this.columns[3].colshow='0';
			}
		},
		CulatefeeOrder(isdown){
			var that=this;
			var paraminfo={
				pageparam:this.pageparam,
				iszb:this.iszb,
				isdown:isdown,
				batch:this.batch
			}
			this.loading=true;
			//this.$tool.loading('正在计算', 'orderpay');
			this.$apipost.get.CulatefeeOrder({paraminfo:paraminfo}).then(res => {
					this.loading=false;
					if(isdown==1){
						this.$tool.loadingclose();
					}
					if(res!=''){
						if(res.state=='1'){
							if(isdown==0){
								if(res.list!=undefined){
									if(res.list.length>0){
										that.batch=res.batch;
										that.orderpaylist=res.list;
										that.sourcelist=JSON.parse(JSON.stringify(that.orderpaylist));
										that.ordersum(false);
									}
									else{
										this.$tool.message('计算失败，请重试', 0);
									}
								}
							}
							else{
								if(res.filename!=undefined){
									that.downsuccess=true;
									that.billname=that.$apiprototype.ApiServer + '/Order/getfile?filename='+ res.filename;
								}else{
									this.$tool.message('收费成功', 1);
								}
							}
						}else{
							this.$tool.message(res.message, 0);
						}
					}
				});
		},
		//筛选列表
		searchpayorder() {
			var search=this.searchbox;
			var orderpaylist=JSON.parse(JSON.stringify(this.sourcelist));
			var filterorder=orderpaylist.filter((p)=>{
				return (p.p_pkval.indexOf(search)>-1 || p.u_account==search);
			});
			this.orderpaylist=filterorder;
		},
		//汇总
		ordersum(isupdate) {
			var that = this;
			var ys=0, ss=0,zerolength=0;
			if(isupdate){
				this.orderpaylist.forEach(a=>{
					var changeamount=a.changeamount;
					var pkval=a.p_pkval;
					for(var i=0;i<that.sourcelist.length;i++){
						if(changeamount!=""){
							if(that.sourcelist[i].p_pkval==pkval){
								that.sourcelist[i].changeamount=parseFloat(changeamount);
								break;
							}
						}else break;
					}
				});
			}
			zerolength=this.sourcelist.filter((p)=>{return p.changeamount==0;}).length;
			this.sourcelist.forEach(e => {
				if(e.amount!="")
					ys+=parseFloat(e.amount);
				if(e.changeamount!="")
					ss+=parseFloat(e.changeamount);
			});
			this.zerolength=zerolength;
			this.ss=ss;
			this.ys=ys;
		},
		surepay(){
			var that=this;
			if(parseFloat(this.ys)==parseFloat(0)){
				this.$tool.message('未计算出金额，无法收费', 0);
				return false;
			}
			if(that.iszb=='0'){
				if(this.paytype==''){
					this.$tool.message('请选择支付方式', 0);
					return false;
				}
			}
			that.btndisabled=true;
			var paraminfo={
				batch:this.batch,
				iszb:this.iszb,
				paytype:this.paytype,
				list:this.sourcelist
			}
			//this.$tool.loading('正在收费', 'orderpay');
			this.loading=true;
			this.$apipost.post.SurePayOrder({paraminfo:paraminfo}).then(res => {
				this.loading=false;
				this.btndisabled=false;
				if(res!=''){
					if(res.state=='1'){
						this.$tool.message('收费完成', 1);
						that.$parent.refreshgrid(true);
						that.showorderpay=false;
					}
					else{
						if(res.filename!=undefined){
							that.showsuccess=true;
							that.errorfile=that.$apiprototype.ApiServer + '/Order/getfile?filename='+ res.filename;
						}
					}
				}
				this.$tool.loadingclose();
			});
		},
		//删除收费临时数据
		DelPayOrderTemp(){
			var that=this;
			if(this.batch!=''){
				this.$apipost.post.DelPayOrderTemp({batch:this.batch}).then(res => {
					//console.log('删除',res);
					that.showorderpay=false;
				});
			}
		},
		downbill(){
			this.CulatefeeOrder(1);
		}
	}
};
</script>
<style>
.el-table .warning-row {
	background: #4f9fee;
	color:#000000;
}
.el-table .danger-row {
	background: #f9a51d;
	color:#000000;
}
</style>
